/**
 * A product's code as it is shown: with its language in front, JP-STEBB, EN-STEBB, CN-STEBB
 * (D, 6 October 2026, "more organised"). Only the showing changes. The code stored stays
 * as it is, so the price sheets that already name it still find it, and one already
 * written with the language in front is not given it twice.
 */
export function productCode(product: { readonly code: string; readonly language?: string | null }): string {
  const language = product.language?.trim().toUpperCase();
  if (!language || product.code.toUpperCase().startsWith(`${language}-`)) return product.code;
  return `${language}-${product.code}`;
}
